import React, { useState } from "react";
import styled from "styled-components";
import ReactApexChart from "react-apexcharts";

export const ColumnChart = () => {
  const productData = {
    series: [
      {
        name: "Uso",
        data: [120, 80, 100, 90, 70, 50, 60, 110],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: true,
          tools: {
            download: false,
          },
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
          distributed: true, // Distribute colors evenly
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [
          "Coca-cola 500cc",
          "Sprite 1.5 litros",
          "Monster Energy",
          "Power Ade Manzana",
          "Cepita del Valle Multifruta",
          "Aquarius Pera",
          "Smartwater",
          "Fanta 2.5 litros",
        ],
      },
      yaxis: {
        title: {
          text: "Cantidad de Uso",
        },
      },
      fill: {
        opacity: 1,
        colors: ["#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0", "#546E7A", "#26a69a", "#D10CE8"],
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + " usos";
          },
        },
      },
      legend: {
        show: false,
      },
    },
  };

  return (
    <MainContainer>
      <ChartColumnCard>
        <HeaderContainer>
          <ChartTitle>Productos más utilizado</ChartTitle>
        </HeaderContainer>
        <ContainerCharts>
          <ReactApexChart options={productData.options} series={productData.series} type="bar" height={350} />
        </ContainerCharts>
      </ChartColumnCard>
    </MainContainer>
  );
};

const MainContainer = styled.div`
  display: flex;
  width: 74%;
  height: 60vh;
  background-color: #c0c0c0;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 30px;
`;

const ChartColumnCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 10px;
`;

const ContainerCharts = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px 10px 10px 10px;
  height: 60%;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 15px;
`;

const ChartTitle = styled.h2`
  font-size: 1.2em;
  color: #333;
  text-align: left;
  font-family: "Roboto", sans-serif;
  margin: 0px;
`;
